import * as React from "react";
import ConnectedThemeProvider from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider";
import merge from "lodash/merge";

const customTheme = {
  overrides: {
    MuiPaper: {
      rounded: {
        borderRadius: "0 !important",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "0 !important",
      },
    },
    PrivateNotchedOutline: {
      root: {
        borderRadius: 0,
      },
    },
    SaveConfiguration: {
      successResult: {
        borderRadius: 0,
      },
    },
    DesignAreaControlbox: {
      colorAmountMessage: {
        borderRadius: 0,
      },
    },
    ImageControlbox: {
      printQuality: {
        visibility: "hidden",
        minHeight: "0px !important",
        height: "0px !important",
        padding: "0px",
        margin: "0px !important",
      },
    },
    MuiDialogTitle: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
      },
    },
    MuiDialogContent: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
      },
    },
    MuiDialogActions: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
        paddingBottom: "16px !important",
      },
    },
    ProductVariant: {
      productAmounts: {
        visibility: "hidden",
      },
    },
    PriceOverview: {
      productVariantWrapper: {
        minHeight: "15vh !important",
      },
    },
  },
};

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    CustomDialog: {
      MuiDialogBorder: {
        maxWidth: 720,
      },
    },
    Option: {
      price: {
        display: "none",
      },
      text: {
        width: "auto",
      },
      image: {
        width: 80,
      },
    },
    MuiDialog: {
      root: {
        [theme.breakpoints.down("sm")]: {
          top: "50px !important",
        },
      },
    },
    DesignerFullScreenView: {
      button: {
        top: -20,
      },
    },
    CallToAction: {
      popper: {
        display: "none",
      }
    },
    EditDesignButton: {
      button: {
        [theme.breakpoints.down("sm")]: {
          visibility: "hidden",
        },
        [theme.breakpoints.up("sm")]: {
          display: "none",
        }
      },
    },
    DesignerAlignTarget: {
      root: {
        marginTop: 10,
      },
    },
    OptionsList: {
      dialogStyle: {
        [theme.breakpoints.down("xl")]: {
          width: 350,
        },
      },
    },

    'Designer-Editor': {
      graphicsEditorContainer: {
        border: 'none !important',
      },
    },
    'Designer-CanvasContainer': {
      canvasContainer: {
        '& canvas': {
          backgroundColor: 'rgba(255,255,255,0.1)',
          border: '1px solid white',
        },
      },
    },
  });
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
